// src/App.js
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './components/Hero';
import VideoSection from './components/VideoSection';
import ReviewSection from './components/ReviewSection';
import LastMinuteOffers from './components/LastMinuteOffers';
import NewsletterBanner from './components/NewsletterBanner';
import Contact from './components/Contact';
import Destinations from './components/Destinations';
import Tours from './components/Tours';

import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function App() {
  return (
    <Router>
      <Navbar />

      <Routes>
        {/* Home Page */}
        <Route
          path="/"
          element={
            <>
              <Hero />
              <VideoSection />
              <ReviewSection />
              <LastMinuteOffers />
              <NewsletterBanner />
            </>
          }
        />

        {/* Other Pages */}
        <Route path="/contact" element={<Contact />} />
        <Route path="/destinations" element={<Destinations />} />
        <Route path="/tours" element={<Tours />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
